import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import compose from 'lodash/flowRight';
import {
    string,
    oneOfType,
    node,
    arrayOf,
    func,
    bool,
    number,
} from 'prop-types';
import classnames from 'classnames';
import { Swipeable } from 'react-swipeable';
import {
    withListingTooltip,
    withOffsetWidth,
    withFeatureFlags,
} from 'connectors';

class ProductCard extends Component {
    productCardEl = null;

    static propTypes = {
        className: string,
        children: oneOfType([node, arrayOf(node)]).isRequired,
        onSwipeLeft: func.isRequired,
        onSwipeRight: func.isRequired,
        hasMerchandizing: bool,
        mobileWidth: number.isRequired,
        registerTooltip: func.isRequired,
        offsetWidth: number.isRequired,
    };

    static defaultProps = {
        className: '',
        hasMerchandizing: false,
    };

    componentDidUpdate(prevProps) {
        if (
            this.productCardEl &&
            !prevProps.hasMerchandizing &&
            this.props.hasMerchandizing
        ) {
            this.props.registerTooltip(this.productCardEl);
        }
    }

    updateRef = ref => {
        if (ref) {
            this.productCardEl = ReactDOM.findDOMNode(ref); // eslint-disable-line
            this.props.registerTooltip(this.productCardEl);
        }
    };

    render() {
        const {
            className,
            children,
            onSwipeLeft,
            onSwipeRight,
            mobileWidth,
            offsetWidth,
        } = this.props;
        const rootClassnames = classnames(
            className,
            'js-product-card',
            'product-card',
        );
        const delta = offsetWidth < mobileWidth ? 60 : 100;

        return (
            <Swipeable
                ref={this.updateRef}
                className={rootClassnames}
                onSwipedLeft={onSwipeLeft}
                onSwipedRight={onSwipeRight}
                delta={delta}
            >
                {children}
            </Swipeable>
        );
    }
}

export default compose(
    withFeatureFlags({
        mobileWidth: 'instantSearch.mobileWidth',
    }),
    withListingTooltip,
    withOffsetWidth,
)(ProductCard);
